import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Box, CardHeader } from '@mui/material';
import {
  LISTING_COLUMNS,
  LISTING_ACTIONS,
} from '../../config/module-configs/report-web-subscriptions.config';
import ListData from '../table-elements/list-data.component';
import { getWebSubscriptionsList } from '../../services/reports.service';
import useAbortableRequest from '../../hooks/abortable-request.hook';
import ViewWebSubscriptionData from './view-web-subscription-data.component';
import { ACTIONS } from '../../config/const.config';

const ListSubscriptionsSummary = ({ selectedChannel }) => {
  const columns = LISTING_COLUMNS;
  const actions = LISTING_ACTIONS;

  const { getSignal, isAbortError } = useAbortableRequest();

  const [options, setOptions] = useState({
    page: 0,
    rowsPerPage: 100,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    sortBy: '',
    sortOrder: '',
    error: false,
    loading: true,
  });
  const [doAction, setDoAction] = useState({
    data: null,
    action: null,
  });

  const handlePageChange = (v) => {
    setOptions({
      ...options,
      page: v,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRowsPerPageChange = (v) => {
    setOptions({
      ...options,
      rowsPerPage: v,
      page: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleSortingChange = (sortBy, sortOrder) => {
    setOptions({
      ...options,
      sortBy,
      sortOrder,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleActionSelect = (selectedAction, selectedData) => {
    setDoAction({
      ...doAction,
      data: selectedData || null,
      action: selectedAction || null,
    });
  };
  const handleActionCancel = () => {
    setDoAction({
      ...doAction,
      data: null,
      action: null,
    });
  };

  useEffect(() => {
    const signal = getSignal();

    const params = [];
    params.push(`page=${options.page + 1}`);
    params.push(`perPage=${options.rowsPerPage}`);
    if (options.sortBy && options.sortOrder) {
      params.push(`sortBy=${options.sortBy}`);
      params.push(`sortOrder=${options.sortOrder}`);
    }
    if (selectedChannel) {
      params.push(`channelId=${selectedChannel}`);
    }

    const paramsQuery = params.length > 0 ? `?${params.join('&')}` : '';
    getWebSubscriptionsList(paramsQuery, signal)
      .then((res) => {
        if (!signal.aborted) {
          setOptions({
            ...options,
            loading: false,
            totalRows: res?.data?.totalRows || 0,
            rows: res?.data?.rows || [],
            error: false,
          });
        }
      })
      .catch((e) => {
        if (isAbortError(e)) {
          return;
        }
        setOptions({
          ...options,
          loading: false,
          page: 0,
          totalRows: 0,
          rows: [],
          error: true,
        });
      });
  }, [options.reloadCounter, selectedChannel]);

  return (
    <Box mt={5}>
      <Card>
        <CardHeader title="Channel Overview" />

        <Box pt={2}>
          <Card>
            <ListData
              columns={columns}
              rows={options.rows}
              page={options.page}
              rowsPerPage={options.rowsPerPage}
              totalRows={options.totalRows}
              loading={options.loading}
              actions={actions}
              error={options.error}
              sortBy={options.sortBy}
              sortOrder={options.sortOrder}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              onSortChange={handleSortingChange}
              onAction={handleActionSelect}
            />
          </Card>
        </Box>
      </Card>

      {doAction.action === ACTIONS.VIEW.value && (
        <ViewWebSubscriptionData
          title={`Subscription Details - ${doAction.data.subscriberName} - ${doAction.data.channelName}`}
          dataId={doAction.data.subscriptionId}
          onCancel={handleActionCancel}
        />
      )}
    </Box>
  );
};

ListSubscriptionsSummary.propTypes = {
  selectedChannel: PropTypes.number.isRequired,
};

export default ListSubscriptionsSummary;
